import React, { useState } from 'react';
import { getOrgTermsContent } from '../../../content/utils.js';

import AuthorizedAction from '../../AuthorizedAction.js';
import SubHeader from '../../SubHeader.jsx';
import Timeline from '../../timeline/index.jsx';
import InitiativesSection from './InitiativesSection.jsx';
import ProjectDetailsHeader from '../../headers/PageHeaders/Project/ProjectDetailsHeader.jsx';
import moment from 'moment';

const isCompleted = (initiative) => moment().isAfter(initiative.endDate, 'day');

const ProjectInitiatives = ({
  onAddActivity,
  deleteInitiative,
  onClickActivity,
  project,
  changeStrategy,
  projectStatuses,
  onShowEditMilestone,
  portfolio,
}) => {
  const [showCompleted, setShowCompleted] = useState(false);

  const activeOnly = (arr) =>
    arr.filter((i) => !i.draft && (showCompleted || !isCompleted(i)));

  const communicationCount = activeOnly(project.communicationInitiatives).length;
  const readinessCount = activeOnly(project.readinessInitiatives).length;
  const trainingCount = activeOnly(project.trainingInitiatives).length;
  const sustainmentCount = activeOnly(project.sustainmentInitiatives).length;
  const initiativeCount =
    communicationCount + readinessCount + trainingCount + sustainmentCount;

  return (
    <React.Fragment>
      <SubHeader flex small>
        <h2>{getOrgTermsContent('initiatives')}</h2>
        <strong className="header-item bordered text-muted">
          Total:&nbsp;
          <span className="text-primary">{initiativeCount}</span>
        </strong>
      </SubHeader>
      {project && projectStatuses ? (
        <ProjectDetailsHeader
          project={project}
          portfolio={portfolio}
          projectStatuses={projectStatuses}
        />
      ) : null}

      <Timeline
        onAddActivity={onAddActivity}
        onShowEditMilestone={onShowEditMilestone}
        onClickActivity={onClickActivity}
        project={project}
        changeStrategy={changeStrategy}
        showCompleted={showCompleted}
        onToggleShowCompleted={setShowCompleted}
      />
      <AuthorizedAction action="read" subject="communicationInitiative">
        <InitiativesSection
          project={project}
          type="communication"
          deleteInitiative={deleteInitiative}
          showCompleted={showCompleted}
        />
      </AuthorizedAction>
      <AuthorizedAction action="read" subject="readinessInitiative">
        <InitiativesSection
          project={project}
          type="readiness"
          deleteInitiative={deleteInitiative}
          showCompleted={showCompleted}
        />
      </AuthorizedAction>
      <AuthorizedAction action="read" subject="trainingInitiative">
        <InitiativesSection
          project={project}
          type="training"
          deleteInitiative={deleteInitiative}
          showCompleted={showCompleted}
        />
      </AuthorizedAction>
      <AuthorizedAction action="read" subject="sustainmentInitiative">
        <InitiativesSection
          project={project}
          type="sustainment"
          deleteInitiative={deleteInitiative}
          showCompleted={showCompleted}
        />
      </AuthorizedAction>
    </React.Fragment>
  );
};

export default ProjectInitiatives;
